import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { CelebrationAnimation } from '@/shared/components/CelebrationAnimation'
import { celebrationAssets } from '@/shared/lib/celebrationAssets'
import {
  REDEEM_SUCCESS_BODY,
  REDEEM_SUCCESS_OK,
  REDEEM_SUCCESS_TITLE,
} from '../lib/rewards-copy'
import {
  redeemSuccessActionsSx,
  redeemSuccessAnimationSx,
  redeemSuccessBodySx,
  redeemSuccessDialogContentSx,
  redeemSuccessDialogPaperSx,
  redeemSuccessIconWrapSx,
  redeemSuccessOkButtonSx,
  redeemSuccessTitleSx,
} from '../styles/redeemSuccessDialogStyles'

interface RedeemSuccessDialogProps {
  readonly open: boolean
  readonly onConfirm: () => void
}

/** Shown after a successful gift-card redemption (BFP-300). */
export function RedeemSuccessDialog({ open, onConfirm }: RedeemSuccessDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onConfirm}
      aria-labelledby="redeem-success-title"
      data-testid="redeem-success-dialog"
      PaperProps={{ sx: redeemSuccessDialogPaperSx }}
    >
      <DialogContent sx={redeemSuccessDialogContentSx}>
        <Box sx={redeemSuccessIconWrapSx}>
          <CelebrationAnimation
            gifSrc={celebrationAssets.redeemCompletedGif}
            playing={open}
            width={200}
            height={200}
            data-testid="redeem-success-animation"
            sx={redeemSuccessAnimationSx}
          />
        </Box>
        <Typography id="redeem-success-title" component="h2" sx={redeemSuccessTitleSx}>
          {REDEEM_SUCCESS_TITLE}
        </Typography>
        <Typography component="p" sx={redeemSuccessBodySx}>
          {REDEEM_SUCCESS_BODY}
        </Typography>
        <Box sx={redeemSuccessActionsSx}>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={redeemSuccessOkButtonSx}
            data-testid="redeem-success-ok"
          >
            {REDEEM_SUCCESS_OK}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
